import React from "react";
import * as Icons from "@wix/wix-ui-icons-common";
import { Tooltip } from "@wix/design-system";

/**
 * Returns Error Icon from Faire Based on matching case
 * @param serviceErrorCode
 * @returns
 */
export const getFaireErrorIcon = (serviceErrorCode: string): JSX.Element | null => {
  switch (serviceErrorCode) {
    case "ProductValidationException.PUBLISHED_PRODUCT_NEEDS_AT_LEAST_ONE_IMAGE":
      return <Icons.Image color="#F69891" />;
    case "ProductValidationException.RETAIL_PRICE_EXCEEDS_MAXIMUM_ALLOWED":
      return <Icons.Refund color="#F69891" />;
    case "ProductValidationException.RETAIL_PRICE_NEEDS_TO_BE_IN_BETWEEN_MULTIPLE_OF_WHOLESALE":
      return <Icons.DataConnect color="#F69891" />;
    case "ProductValidationException.RETAIL_OR_WHOLESALE_PRICE_NEEDS_TO_BE_GREATER_THAN_ZERO":
      return <Icons.Payment color="#F69891" />;
    case "ProductValidationException.DUPLICATE_VARIANT_OPTIONS":
      return <Icons.Duplicate color="#F69891" />;
    default:
      return null;
  }
};

/**
 * Retrieves only the unique error icons
 * @param exportErrors
 * @returns
 */
export const getUniqueErrorIcons = (exportErrors: any[]) => {
  const uniqueErrorCodes = new Set<string>();

  return exportErrors.map((item, index) => {
    const serviceErrorCode = item?.service_error_code;
    if (!uniqueErrorCodes.has(serviceErrorCode)) {
      const iconComponent = getFaireErrorIcon(serviceErrorCode);
      if (iconComponent) {
        uniqueErrorCodes.add(serviceErrorCode);
        return (
          <Tooltip key={index} placement="top" content={item.message}>
            {iconComponent}
          </Tooltip>
        );
      }
    }
    return null;
  });
};

export const getExportToFaireErrorMsg = (message: any) => {
  let real_message = message;
  message = message.toLowerCase();
  if (message.includes("needs to be between 1.25 and 10 times")) {
    return real_message + ". Please edit the price and export the product again.";
  }

  if (message.includes("duplicate variants with same options")) {
    return `Product already exists in Faire with same variants and options. Faire does not allows product variants with same options.`;
  }

  if (message.includes("requires positive field")) {
    if (message.includes("retail_price.amount_minor")) {
      return "Variant Retail Price Must be at least more than 0 and needs to be between 1.25 and 10 times the wholesale price";
    }
    if (message.includes("wholesale_price.amount_minor")) {
      return "Variant Wholesale Price Must be at least more than 0 and needs to be between 1.25 and 10 times the retail price";
    }
  }
  return real_message;
};
